module.exports = __webpack_public_path__ + "img/normal.ab0b9c12.png";